/*
 * Public API Surface of ngx-translate-router-http-loader
 */

export * from './lib/http-loader';
